import {Serializer, Serializers} from "../../interfaces/serializer";
import {Language} from "../../interfaces/language";
import {Lang} from '../../interfaces/ad-reports';

export const LANGUAGES_STATE_NAME = 'languages';

export interface LanguagesState {
  languages: Serializers<Language>;
  language: Serializer<Language>;
  languageCode: Lang;
  loading: boolean;
  loaded: boolean;
}
